const textDefaults = {
  'EN': {
    'welcomeTitle': 'Social compliance check',
    'welcomeReason': 'To ensure social compliance, we need to ask some questions and have some documents validated.',
    'finishedTitle': 'Ready to submit',
    'finishedReason': 'On submitting, the data you provided will be carefully reviewed and additional checks might be necessary.',
    'scanningTitle': 'Upload your documents',
    'scanningText': 'Capture or select an image of your document where the edges are visible and all text is clearly readable.',
    'errorNotRecognised': 'Document not recognized',
    'errorWrongType': 'We expected a {expectedType} file but you provided a {uploadedFileType}',
    'lblExpires': 'Expires',
    'lblUploadOrCapture': 'Upload or capture an image of the requested document',
    'lblVAT': 'VAT',
    'VATText': 'Please provide your VAT number',
    'VATError': 'This is not a valid VAT number, please make sure that you enter a correct VAT number',
    'lblBE': 'Belgium',
    'lblNonBE': 'Other country',
    'lblEER': 'EEA Country (EU27 (incl. BE) / Iceland / Norway / Liechtenstein / Switzerland)',
    'lblNonEER': 'Other country',
    'employeeDetailText': 'Please provide the following information',
    'requestException': 'I want to request an exception',
    'requestExceptionProofOfIndependence': 'I don\'t have proof of independence',
    'exceptionIntroLimosa': 'If you comply with one of the following exceptions, you do not need to apply for a Limosa.',
    'installationAndAssembly': 'Installation and assembly (max. 8 days)',
    'exceptionFirstDescriptionLimosa': 'Workers and self-employed people sent to Belgium for the initial assembly and/or installation of goods are exempt. This applies only to qualified and/or specialised workers in the business supplying the goods, or the self-employed supplier. <strong>The work may not exceed 8 days.</strong> This exemption does not apply to the construction sector.',
    'urgentRepairAndMaintenanceWork': 'Urgent repair and maintenance work (max. 5 days)',
    'exceptionSecondDescriptionLimosa': 'Specialized technicians from foreign companies and self-employed people are exempt if they come to Belgium to carry out urgent maintenance or repair work on machines or equipment. Machines or equipment must have been delivered by their employer or by the self-employed people themselves to the business where the repair/maintenance took place. Such technicians may not stay on Belgian soil for <strong>more than 5 days per month</strong>.',
    'exceptionExtraInformation': 'More information',
    'exceptionConfirmationIntro': 'I hereby confirm that I comply with the following exception rule:',
    'exceptionFrom': 'From',
    'exceptionTo': 'To',
    'exceptionSignature': 'Signature',
    'exceptionIndependence': 'I hereby confirm that I am an Independent according to Belgian Law:',
    'GroupSelectionText': 'For what company are you performing this task?',
    'CountryLocationText': 'Where is your company registered?',
    'EmployeeLocationText': 'Where are you registered?',
    'selfEmployedText': 'Are you self-employed?',
    'yes': 'Yes',
    'no': 'No',
    'lblNL': 'Netherlands',
    'lblNonNL': 'Other country',
    'nationalityText': 'Please select your nationality',
    'exceptionSelectionText': 'Is your visit covered under one of the following exceptions?',
    'durationSelectionText': 'Are you staying longer than 90 days?',
    'scanningHelperText': 'More information',
    'nationalityPlaceholder': 'Nationality',
    'expiredError': 'Document expired or will expire too soon',
    'a1NationalityMismatch': 'The member state on your A1 (issuing country) does not correspond with your provided answer in the previous step. Go back to the previous screen and select the correct answer.',
  },
  'FR': {
    'welcomeTitle': 'Vérification de conformité sociale',
    'welcomeReason': 'Pour assurer la conformité sociale, nous devons poser quelques questions et faire valider certains documents.',
    'finishedTitle': 'Prêt à soumettre',
    'finishedReason': 'En soumettant, les données que vous avez fournies seront soigneusement examinées et des vérifications supplémentaires pourraient être nécessaires.',
    'scanningTitle': 'Téléchargez vos documents',
    'scanningText': 'Prenez ou sélectionnez une image de votre document où les bords sont visibles et tout le texte est clairement lisible.',
    'errorNotRecognised': 'Document non reconnu',
    'errorWrongType': 'Nous attendions un fichier {expectedType} mais vous avez fourni un {uploadedFileType}',
    'lblExpires': 'Expire',
    'lblUploadOrCapture': 'Téléchargez ou prenez une photo de votre document',
    'lblVAT': 'TVA',
    'VATText': 'Veuillez fournir votre numéro de TVA',
    'VATError': 'Ce n\'est pas un numéro de TVA valide, veuillez vous assurer de saisir un numéro de TVA correct',
    'lblBE': 'Belgique',
    'lblNonBE': 'Autre pays',
    'lblEER': 'Pays de l’EEE (UE27 (incl. BE) / Islande / Norvège / Liechtenstein / Suisse)',
    'lblNonEER': 'Autre pays',
    'employeeDetailText': 'Veuillez fournir les informations suivantes',
    'requestException': 'Je souhaite demander une exception',
    'requestExceptionProofOfIndependence': 'Je n’ai pas de justificatif de statut indépendant.',
    'exceptionIntroLimosa': 'Si vous répondez à l’une des exceptions suivantes, vous n’avez pas besoin de demander une Limosa.',
    'installationAndAssembly': 'Installation et assemblage (max. 8 jours)',
    'exceptionFirstDescriptionLimosa': 'Les travailleurs et indépendants envoyés en Belgique pour le montage et/ou l’installation initiale de marchandises sont exemptés. Cela ne s’applique qu’aux travailleurs qualifiés et/ou spécialisés dans l’entreprise fournissant les marchandises, ou au fournisseur indépendant. <strong>Le travail ne peut excéder 8 jours.</strong> Cette exemption ne s’applique pas au secteur de la construction.',
    'urgentRepairAndMaintenanceWork': 'Travaux de réparation et d’entretien urgents (max. 5 jours)',
    'exceptionSecondDescriptionLimosa': 'Les techniciens spécialisés d’entreprises étrangères et les travailleurs indépendants sont exemptés s’ils viennent en Belgique pour effectuer des travaux urgents de maintenance ou de réparation sur des machines ou des équipements. Les machines ou équipements doivent avoir été livrés par leur employeur ou par les indépendants eux-mêmes à l’entreprise où la réparation/entretien a eu lieu. Ces techniciens ne peuvent pas rester sur le sol belge <strong>plus de 5 jours par mois</strong>.',
    'exceptionExtraInformation': 'Plus d’informations',
    'exceptionConfirmationIntro': 'Je confirme par la présente que je respecte la règle d’exception suivante:',
    'exceptionFrom': 'De',
    'exceptionTo': 'À',
    'exceptionSignature': 'Signature',
    'exceptionIndependence': 'Je confirme par la présente que je suis indépendant selon la législation belge:',
    'GroupSelectionText': 'Pour quelle entreprise effectuez-vous cette tâche?',
    'CountryLocationText': 'Où votre entreprise est-elle enregistrée?',
    'EmployeeLocationText': 'Où êtes-vous enregistré(e)?',
    'selfEmployedText': 'Êtes-vous indépendant(e)?',
    'yes': 'Oui',
    'no': 'Non',
    'lblNL': 'Pays-Bas',
    'lblNonNL': 'Autre pays',
    'nationalityText': 'Veuillez sélectionner votre nationalité',
    'exceptionSelectionText': 'Votre séjour est-il couvert par l\'une des exceptions suivantes?',
    'durationSelectionText': 'Vous restez plus de 90 jours?',
    'scanningHelperText': 'Plus d\'informations',
    'nationalityPlaceholder': 'Nationalité',
    'expiredError': 'Document expiré ou expirera trop rapidement',
    'a1NationalityMismatch': 'L\'État membre figurant sur votre A1 (pays émetteur) ne correspond pas à la réponse que vous avez fournie à l\'étape précédente. Retournez à l\'écran précédent et sélectionnez la bonne réponse.',
  },
  'DE': {
    'welcomeTitle': 'Überprüfung der Sozialkonformität',
    'welcomeReason': 'Um die Sozialkonformität sicherzustellen, müssen wir einige Fragen stellen und Dokumente überprüfen lassen.',
    'finishedTitle': 'Bereit zum Einreichen',
    'finishedReason': 'Nach dem Einreichen werden die von Ihnen bereitgestellten Daten sorgfältig geprüft, und es können zusätzliche Überprüfungen erforderlich sein.',
    'scanningTitle': 'Laden Sie Ihre Dokumente hoch',
    'scanningText': 'Erfassen oder wählen Sie ein Bild Ihres Dokuments, bei dem die Ränder sichtbar sind und der gesamte Text gut lesbar ist.',
    'errorNotRecognised': 'Dokument nicht erkannt',
    'errorWrongType': 'Wir erwarteten eine {expectedType}-Datei, aber Sie haben eine {uploadedFileType} bereitgestellt',
    'lblExpires': 'Läuft ab',
    'lblUploadOrCapture': 'Hochladen oder ein Bild aufnehmen von dem angeforderten Dokument',
    'lblVAT': 'MwSt',
    'VATText': 'Bitte geben Sie Ihre MwSt-Nummer an',
    'VATError': 'Dies ist keine gültige MwSt-Nummer, bitte stellen Sie sicher, dass Sie eine korrekte MwSt-Nummer eingeben',
    'lblBE': 'Belgien',
    'lblNonBE': 'Anderes Land',
    'lblEER': 'EWR-Land (EU27 (einschl. BE) / Island / Norwegen / Liechtenstein / Schweiz)',
    'lblNonEER': 'Anderes Land',
    'employeeDetailText': 'Bitte geben Sie die folgenden Informationen an',
    'requestException': 'Ich möchte eine Ausnahme beantragen',
    'requestExceptionProofOfIndependence': 'Ich habe keinen Nachweis über meine Selbstständigkeit.',
    'exceptionIntroLimosa': 'Wenn Sie eine der folgenden Ausnahmen erfüllen, müssen Sie keinen Limosa-Antrag stellen.',
    'installationAndAssembly': 'Installation und Montage (max. 8 Tage)',
    'exceptionFirstDescriptionLimosa': 'Arbeiter und Selbständige, die zur Erstmontage und/oder Installation von Waren nach Belgien entsandt werden, sind befreit. Dies gilt nur für qualifizierte und/oder spezialisierte Arbeiter im Unternehmen, das die Waren liefert, oder für den selbständigen Lieferanten. <strong>Die Arbeit darf 8 Tage nicht überschreiten.</strong> Diese Ausnahme gilt nicht für das Bauwesen.',
    'urgentRepairAndMaintenanceWork': 'Dringende Reparatur- und Wartungsarbeiten (max. 5 Tage)',
    'exceptionSecondDescriptionLimosa': 'Spezialisierte Techniker von ausländischen Unternehmen und Selbstständige sind befreit, wenn sie nach Belgien kommen, um dringende Wartungs- oder Reparaturarbeiten an Maschinen oder Geräten durchzuführen. Maschinen oder Geräte müssen von ihrem Arbeitgeber oder von ihnen selbst an das Unternehmen geliefert worden sein, in dem die Reparatur/Wartung durchgeführt wurde. Solche Techniker dürfen sich <strong>nicht länger als 5 Tage pro Monat</strong> auf belgischem Boden aufhalten.',
    'exceptionExtraInformation': 'Weitere Informationen',
    'exceptionConfirmationIntro': 'Ich bestätige hiermit, dass ich die folgende Ausnahme-Regel einhalte:',
    'exceptionFrom': 'Von',
    'exceptionTo': 'Bis',
    'exceptionSignature': 'Unterschrift',
    'exceptionIndependence': 'Ich bestätige hiermit, dass ich gemäß belgischem Recht selbstständig bin:',
    'GroupSelectionText': 'Für welches Unternehmen führen Sie diese Aufgabe aus?',
    'CountryLocationText': 'Wo ist Ihr Unternehmen registriert?',
    'EmployeeLocationText': 'Wo sind Sie registriert?',
    'selfEmployedText': 'Sind Sie selbstständig?',
    'yes': 'Ja',
    'no': 'Nein',
    'lblNL': 'Niederlande',
    'lblNonNL': 'Anderes Land',
    'nationalityText': 'Bitte wählen Sie Ihre Nationalität',
    'exceptionSelectionText': 'Ist Ihre Reise von einer der folgenden Ausnahmen abgedeckt?',
    'durationSelectionText': 'Bleiben Sie länger als 90 Tage?',
    'scanningHelperText': 'Mehr Informationen',
    'nationalityPlaceholder': 'Nationalität',
    'expiredError': 'Dokument verloren oder wird zu bald ablaufen',
    'a1NationalityMismatch': 'Der auf Ihrem A1 angegebene Mitgliedstaat (ausstellendes Land) stimmt nicht mit Ihrer Angabe im vorherigen Schritt überein. Gehen Sie zum vorherigen Bildschirm zurück und wählen Sie die richtige Antwort.',
  },
  'NL': {
    'welcomeTitle': 'Controle op sociale naleving',
    'welcomeReason': 'Om de sociale naleving te waarborgen, moeten we enkele vragen stellen en bepaalde documenten laten valideren.',
    'finishedTitle': 'Klaar om te verzenden',
    'finishedReason': 'Bij het verzenden worden de door u verstrekte gegevens zorgvuldig beoordeeld en kunnen aanvullende controles nodig zijn.',
    'scanningTitle': 'Upload uw documenten',
    'scanningText': 'Maak of selecteer een afbeelding van uw document waarbij de randen zichtbaar zijn en alle tekst goed leesbaar is.',
    'errorNotRecognised': 'Document niet herkend',
    'errorWrongType': 'We verwachtten een {expectedType} bestand maar u heeft een {uploadedFileType} aangeleverd',
    'lblExpires': 'Verloopt',
    'lblUploadOrCapture': 'Upload of maak een foto van het aangevraagde document',
    'lblVAT': 'BTW',
    'VATText': 'Geef uw btw-nummer op',
    'VATError': 'Dit is geen geldig btw-nummer, zorg ervoor dat u een correct btw-nummer invoert',
    'lblBE': 'België',
    'lblNonBE': 'Ander land',
    'lblEER': 'EER-land (EU27 (incl. BE) / IJsland / Noorwegen / Liechtenstein / Zwitserland)',
    'lblNonEER': 'Ander land',
    'employeeDetailText': 'Gelieve de volgende informatie te verstrekken',
    'requestException': 'Ik wil een uitzondering aanvragen',
    'requestExceptionProofOfIndependence': 'Ik heb geen bewijs van zelfstandigheid.',
    'exceptionIntroLimosa': 'Als u aan een van de volgende uitzonderingen voldoet, hoeft u geen Limosa aan te vragen.',
    'installationAndAssembly': 'Installatie en montage (max. 8 dagen)',
    'exceptionFirstDescriptionLimosa': 'Werknemers en zelfstandigen die naar België worden gestuurd voor de eerste montage en/of installatie van goederen zijn vrijgesteld. Dit geldt alleen voor gekwalificeerde en/of gespecialiseerde werknemers in het bedrijf dat de goederen levert, of de zelfstandige leverancier. <strong>Het werk mag niet langer dan 8 dagen duren.</strong> Deze vrijstelling geldt niet voor de bouwsector.',
    'urgentRepairAndMaintenanceWork': 'Dringende reparatie- en onderhoudswerken (max. 5 dagen)',
    'exceptionSecondDescriptionLimosa': 'Gespecialiseerde technici van buitenlandse bedrijven en zelfstandigen zijn vrijgesteld als ze naar België komen om dringende onderhouds- of reparatiewerkzaamheden aan machines of apparatuur uit te voeren. De machines of apparatuur moeten door hun werkgever of door de zelfstandigen zelf zijn geleverd aan het bedrijf waar de reparatie/onderhoud plaatsvond. Dergelijke technici mogen <strong>niet langer dan 5 dagen per maand</strong> op Belgisch grondgebied verblijven.',
    'exceptionExtraInformation': 'Meer informatie',
    'exceptionConfirmationIntro': 'Hierbij bevestig ik dat ik voldoe aan de volgende uitzonderingsregel:',
    'exceptionFrom': 'Van',
    'exceptionTo': 'Tot',
    'exceptionSignature': 'Handtekening',
    'exceptionIndependence': 'Ik verklaar hierbij dat ik zelfstandige ben volgens de Belgische wetgeving:',
    'GroupSelectionText': 'Voor welke bedrijf voert u deze taak uit?',
    'CountryLocationText': 'Waar is uw bedrijf geregistreerd?',
    'EmployeeLocationText': 'Waar bent u geregistreerd?',
    'selfEmployedText': 'Bent u zelfstandig?',
    'yes': 'Ja',
    'no': 'Nee',
    'lblNL': 'Nederland',
    'lblNonNL': 'Ander land',
    'nationalityText': 'Kies uw nationaliteit',
    'scanningHelperText': 'Meer informatie',
    'durationSelectionText': 'Blijft u langer dan 90 dagen?',
    'exceptionSelectionText': 'Is uw verblijf gedekt door een van de volgende uitzonderingen?',
    'nationalityPlaceholder': 'Nationaliteit',
    'expiredError': 'Document verlopen of zal te snel verlopen',
    'a1NationalityMismatch': 'De lidstaat op uw A1 (uitgevend land) komt niet overeen met het antwoord dat u in de vorige stap heeft gegeven. Ga terug naar het vorige scherm en selecteer het juiste antwoord.',
  },
  'PL': {
    'welcomeTitle': 'Kontrola zgodności społecznej',
    'welcomeReason': 'Aby zapewnić zgodność społeczną, musimy zadać kilka pytań i zweryfikować dokumenty.',
    'finishedTitle': 'Gotowy do przesłania',
    'finishedReason': 'Po przesłaniu dostarczone dane zostaną dokładnie przeanalizowane i mogą być wymagane dodatkowe kontrole.',
    'scanningTitle': 'Prześlij swoje dokumenty',
    'scanningText': 'Zrób lub wybierz zdjęcie dokumentu, na którym krawędzie są widoczne, a cały tekst jest czytelny.',
    'errorNotRecognised': 'Dokument nierozpoznany',
    'errorWrongType': 'Oczekiwaliśmy pliku {expectedType}, ale przesłano {uploadedFileType}',
    'lblExpires': 'Wygasa',
    'lblUploadOrCapture': 'Prześlij lub zrób zdjęcie wymaganego dokumentu',
    'lblVAT': 'VAT',
    'VATText': 'Podaj swój numer VAT',
    'VATError': 'To nie jest prawidłowy numer VAT, upewnij się, że wprowadzasz prawidłowy numer VAT',
    'lblBE': 'Belgia',
    'lblNonBE': 'Inny kraj',
    'lblEER': 'Kraj EOG (UE27 (w tym BE) / Islandia / Norwegia / Liechtenstein / Szwajcaria)',
    'lblNonEER': 'Inny kraj',
    'employeeDetailText': 'Podaj następujące informacje',
    'requestException': 'Chcę złożyć wniosek o wyjątek',
    'requestExceptionProofOfIndependence': 'Nie mam dokumentu potwierdzającego, że jestem niezależnym wykonawcą.',
    'exceptionIntroLimosa': 'Jeśli spełniasz jeden z poniższych wyjątków, nie musisz ubiegać się o Limosa.',
    'installationAndAssembly': 'Montaż i instalacja (maks. 8 dni)',
    'exceptionFirstDescriptionLimosa': 'Pracownicy i osoby samozatrudnione wysłane do Belgii w celu początkowego montażu i/lub instalacji towarów są zwolnione. Dotyczy to tylko wykwalifikowanych i/lub wyspecjalizowanych pracowników w firmie dostarczającej towary lub samozatrudnionego dostawcy. <strong>Praca nie może przekraczać 8 dni.</strong> Zwolnienie to nie dotyczy sektora budowlanego.',
    'urgentRepairAndMaintenanceWork': 'Pilne prace naprawcze i konserwacyjne (maks. 5 dni)',
    'exceptionSecondDescriptionLimosa': 'Specjalistyczni technicy z firm zagranicznych oraz osoby samozatrudnione są zwolnieni, jeśli przyjeżdżają do Belgii, aby przeprowadzić pilne prace konserwacyjne lub naprawcze na maszynach lub urządzeniach. Maszyny lub urządzenia muszą zostać dostarczone przez ich pracodawcę lub przez same osoby samozatrudnione do firmy, w której naprawa/konserwacja miała miejsce. Tacy technicy nie mogą przebywać na terytorium Belgii <strong>więcej niż 5 dni w miesiącu</strong>.',
    'exceptionExtraInformation': 'Więcej informacji',
    'exceptionConfirmationIntro': 'Potwierdzam, że spełniam następującą zasadę wyjątku:',
    'exceptionFrom': 'Od',
    'exceptionTo': 'Do',
    'exceptionSignature': 'Podpis',
    'exceptionIndependence': 'Niniejszym potwierdzam, że jestem osobą samozatrudnioną zgodnie z prawem belgijskim:',
    'GroupSelectionText': 'Dla jakiej firmy wykonujesz tę pracę?',
    'CountryLocationText': 'Gdzie jest zarejestrowana Twoja firma?',
    'EmployeeLocationText': 'Gdzie jesteś zarejestrowany?',
    'selfEmployedText': 'Czy jesteś samozatrudniony?',
    'yes': 'Tak',
    'no': 'Nie',
    'lblNL': 'Niederlande',
    'lblNonNL': 'Inne państwo',
    'nationalityText': 'Wybierz swoją narodowość',
    'scanningHelperText': 'Więcej informacji',
    'durationSelectionText': 'Zostaniesz dłużej niż 90 dni?',
    'exceptionSelectionText': 'Czy Twój pobyt jest objęty jedną z poniższych wyjątków?',
    'nationalityPlaceholder': 'Narodowość',
    'expiredError': 'Dokument wygasł lub wygaśnie za krótko',
    'a1NationalityMismatch': 'Państwo członkowskie na dokumencie A1 (kraj wydający) nie odpowiada odpowiedzi udzielonej w poprzednim kroku. Wróć do poprzedniego ekranu i wybierz poprawną odpowiedź.',
  },
  'BG': {
    'welcomeTitle': 'Проверка на социално съответствие',
    'welcomeReason': 'За да гарантираме социалното съответствие, трябва да зададем няколко въпроса и да валидираме някои документи.',
    'finishedTitle': 'Готово за изпращане',
    'finishedReason': 'При изпращане предоставените данни ще бъдат внимателно прегледани и може да са необходими допълнителни проверки.',
    'scanningTitle': 'Качете вашите документи',
    'scanningText': 'Направете или изберете снимка на документа, където краищата са видими и целият текст е ясно четим.',
    'errorNotRecognised': 'Документът не е разпознат',
    'errorWrongType': 'Очаквахме файл {expectedType}, но предоставихте {uploadedFileType}',
    'lblExpires': 'Изтича',
    'lblUploadOrCapture': 'Качете или направете снимка на искания документ',
    'lblVAT': 'ДДС',
    'VATText': 'Моля, предоставете вашия номер за ДДС',
    'VATError': 'Това не е валиден номер за ДДС, моля уверете се, че въвеждате правилен номер за ДДС',
    'lblBE': 'Белгия',
    'lblNonBE': 'Друга държава',
    'lblEER': 'Държава от ЕИП (ЕС27 (включва BE) / Исландия / Норвегия / Лихтенщайн / Швейцария)',
    'lblNonEER': 'Друга държава',
    'employeeDetailText': 'Моля, предоставете следната информация',
    'requestException': 'Искам да поискам изключение',
    'requestExceptionProofOfIndependence': 'Нямам доказателство за независимост',
    'exceptionIntroLimosa': 'Ако отговаряте на едно от следните изключения, не е необходимо да кандидатствате за Limosa.',
    'installationAndAssembly': 'Монтаж и сглобяване (макс. 8 дни)',
    'exceptionFirstDescriptionLimosa': 'Работниците и самозанетите лица, изпратени в Белгия за първоначално сглобяване и/или монтаж на стоки, са освободени. Това се прилага само за квалифицирани и/или специализирани работници в бизнеса, доставящ стоките, или самозанетия доставчик. <strong>Работата не може да надхвърля 8 дни.</strong> Това изключение не се прилага за строителния сектор.',
    'urgentRepairAndMaintenanceWork': 'Спешни ремонтни и поддържащи работи (макс. 5 дни)',
    'exceptionSecondDescriptionLimosa': 'Специализираните техници от чуждестранни компании и самозанетите лица са освободени, ако идват в Белгия за извършване на спешни поддържащи или ремонтни работи по машини или оборудване. Машините или оборудването трябва да са доставени от техния работодател или от самите самозанети лица в бизнеса, където е извършен ремонтът/поддръжката. Такива техници не могат да останат на белгийска територия <strong>повече от 5 дни месечно</strong>.',
    'exceptionExtraInformation': 'Повече информация',
    'exceptionConfirmationIntro': 'Настоящото потвърждавам, че отговарям на следното правило за изключение:',
    'exceptionFrom': 'От',
    'exceptionTo': 'До',
    'exceptionSignature': 'Подпис',
    'exceptionIndependence': 'Настоящото потвърждавам, че съм независим съгласно белгийското законодателство:',
    'GroupSelectionText': 'За коя компания извършвате тази задача?',
    'CountryLocationText': 'Къде е регистрирана вашата компания?',
    'EmployeeLocationText': 'Къде сте регистриран?',
    'selfEmployedText': 'Сте ли самозанет?',
    'yes': 'Да',
    'no': 'Не',
    'lblNL': 'Нидерландия',
    'lblNonNL': 'Друга държава',
    'nationalityText': 'Моля, изберете вашата националност',
    'exceptionSelectionText': 'Вашият престой покрит ли е от едно от следните изключения?',
    'durationSelectionText': 'Оставате ли повече от 90 дни?',
    'scanningHelperText': 'Повече информация',
    'nationalityPlaceholder': 'Националност',
    'expiredError': 'Документът е изтекъл или ще изтече твърде скоро',
    'a1NationalityMismatch': 'Държавата членка на вашия A1 (издаваща държава) не съответства на предоставения от вас отговор в предишната стъпка. Върнете се на предишния екран и изберете правилния отговор.',
  },
  'CS': {
    'welcomeTitle': 'Kontrola sociální shody',
    'welcomeReason': 'Abychom zajistili sociální shodu, musíme položit několik otázek a nechat ověřit některé dokumenty.',
    'finishedTitle': 'Připraveno k odeslání',
    'finishedReason': 'Při odesílání budou poskytnutá data pečlivě zkontrolována a mohou být nutné další kontroly.',
    'scanningTitle': 'Nahrajte své dokumenty',
    'scanningText': 'Pořiďte nebo vyberte obrázek dokumentu, kde jsou okraje viditelné a veškerý text je jasně čitelný.',
    'errorNotRecognised': 'Dokument nerozpoznán',
    'errorWrongType': 'Očekávali jsme soubor {expectedType}, ale poskytli jste {uploadedFileType}',
    'lblExpires': 'Vyprší',
    'lblUploadOrCapture': 'Nahrajte nebo pořiďte obrázek požadovaného dokumentu',
    'lblVAT': 'DPH',
    'VATText': 'Uveďte prosím své DIČ',
    'VATError': 'Toto není platné DIČ, ujistěte se, že zadáváte správné DIČ',
    'lblBE': 'Belgie',
    'lblNonBE': 'Jiná země',
    'lblEER': 'Země EHP (EU27 (vč. BE) / Island / Norsko / Lichtenštejnsko / Švýcarsko)',
    'lblNonEER': 'Jiná země',
    'employeeDetailText': 'Uveďte prosím následující informace',
    'requestException': 'Chci požádat o výjimku',
    'requestExceptionProofOfIndependence': 'Nemám doklad o nezávislosti',
    'exceptionIntroLimosa': 'Pokud splňujete jednu z následujících výjimek, nemusíte žádat o Limosa.',
    'installationAndAssembly': 'Instalace a montáž (max. 8 dní)',
    'exceptionFirstDescriptionLimosa': 'Pracovníci a OSVČ vyslaní do Belgie pro počáteční montáž a/nebo instalaci zboží jsou osvobozeni. To se vztahuje pouze na kvalifikované a/nebo specializované pracovníky v podniku dodávajícím zboží nebo na samostatného dodavatele. <strong>Práce nesmí překročit 8 dní.</strong> Toto osvobození se nevztahuje na stavební sektor.',
    'urgentRepairAndMaintenanceWork': 'Naléhavé opravy a údržba (max. 5 dní)',
    'exceptionSecondDescriptionLimosa': 'Specializovaní technici ze zahraničních společností a OSVČ jsou osvobozeni, pokud přicházejí do Belgie provádět naléhavé údržbářské nebo opravárenské práce na strojích nebo zařízeních. Stroje nebo zařízení musely být dodány jejich zaměstnavatelem nebo samotnými OSVČ do podniku, kde proběhla oprava/údržba. Tito technici nesmějí zůstat na belgickém území <strong>déle než 5 dní měsíčně</strong>.',
    'exceptionExtraInformation': 'Více informací',
    'exceptionConfirmationIntro': 'Tímto potvrzuji, že splňuji následující výjimku:',
    'exceptionFrom': 'Od',
    'exceptionTo': 'Do',
    'exceptionSignature': 'Podpis',
    'exceptionIndependence': 'Tímto potvrzuji, že jsem nezávislý podle belgického práva:',
    'GroupSelectionText': 'Pro jakou společnost tuto úlohu vykonáváte?',
    'CountryLocationText': 'Kde je vaše společnost registrována?',
    'EmployeeLocationText': 'Kde jste registrováni?',
    'selfEmployedText': 'Jste OSVČ?',
    'yes': 'Ano',
    'no': 'Ne',
    'lblNL': 'Nizozemsko',
    'lblNonNL': 'Jiná země',
    'nationalityText': 'Vyberte prosím svou národnost',
    'exceptionSelectionText': 'Je váš pobyt pokrytý jednou z následujících výjimek?',
    'durationSelectionText': 'Zůstáváte déle než 90 dní?',
    'scanningHelperText': 'Více informací',
    'nationalityPlaceholder': 'Národnost',
    'expiredError': 'Dokument vypršel nebo brzy vyprší',
    'a1NationalityMismatch': 'Členský stát uvedený na vašem A1 (vydávající země) neodpovídá vámi uvedené odpovědi v předchozím kroku. Vraťte se na předchozí obrazovku a vyberte správnou odpověď.',
  },
  'DA': {
    'welcomeTitle': 'Kontrol af social overholdelse',
    'welcomeReason': 'For at sikre social overholdelse skal vi stille nogle spørgsmål og få valideret nogle dokumenter.',
    'finishedTitle': 'Klar til indsendelse',
    'finishedReason': 'Ved indsendelse vil de oplysninger, du har angivet, blive omhyggeligt gennemgået, og der kan være behov for yderligere kontroller.',
    'scanningTitle': 'Upload dine dokumenter',
    'scanningText': 'Tag eller vælg et billede af dit dokument hvor kanterne er synlige og al tekst er tydeligt læsbar.',
    'errorNotRecognised': 'Dokument ikke genkendt',
    'errorWrongType': 'Vi forventede en {expectedType} fil, men du leverede en {uploadedFileType}',
    'lblExpires': 'Udløber',
    'lblUploadOrCapture': 'Upload eller tag et billede af det anmodede dokument',
    'lblVAT': 'Moms',
    'VATText': 'Angiv venligst dit CVR-nummer',
    'VATError': 'Dette er ikke et gyldigt CVR-nummer, sørg for at du indtaster et korrekt CVR-nummer',
    'lblBE': 'Belgien',
    'lblNonBE': 'Andet land',
    'lblEER': 'EØS-land (EU27 (inkl. BE) / Island / Norge / Liechtenstein / Schweiz)',
    'lblNonEER': 'Andet land',
    'employeeDetailText': 'Angiv venligst følgende oplysninger',
    'requestException': 'Jeg vil anmode om en undtagelse',
    'requestExceptionProofOfIndependence': 'Jeg har ikke bevis for selvstændighed',
    'exceptionIntroLimosa': 'Hvis du overholder en af følgende undtagelser, behøver du ikke ansøge om en Limosa.',
    'installationAndAssembly': 'Installation og montage (maks. 8 dage)',
    'exceptionFirstDescriptionLimosa': 'Arbejdere og selvstændige sendt til Belgien til den indledende montage og/eller installation af varer er fritaget. Dette gælder kun for kvalificerede og/eller specialiserede arbejdere i virksomheden, der leverer varerne, eller den selvstændige leverandør. <strong>Arbejdet må ikke overstige 8 dage.</strong> Denne undtagelse gælder ikke for byggeindustrien.',
    'urgentRepairAndMaintenanceWork': 'Hastereparationer og vedligeholdelsesarbejde (maks. 5 dage)',
    'exceptionSecondDescriptionLimosa': 'Specialiserede teknikere fra udenlandske virksomheder og selvstændige er fritaget, hvis de kommer til Belgien for at udføre hastereparationer eller vedligeholdelsesarbejde på maskiner eller udstyr. Maskiner eller udstyr skal være blevet leveret af deres arbejdsgiver eller af de selvstændige selv til virksomheden, hvor reparationen/vedligeholdelsen fandt sted. Sådanne teknikere må ikke opholde sig på belgisk jord i <strong>mere end 5 dage om måneden</strong>.',
    'exceptionExtraInformation': 'Mere information',
    'exceptionConfirmationIntro': 'Jeg bekræfter hermed, at jeg overholder følgende undtagelsesregel:',
    'exceptionFrom': 'Fra',
    'exceptionTo': 'Til',
    'exceptionSignature': 'Underskrift',
    'exceptionIndependence': 'Jeg bekræfter hermed, at jeg er selvstændig i henhold til belgisk lov:',
    'GroupSelectionText': 'For hvilket firma udfører du denne opgave?',
    'CountryLocationText': 'Hvor er dit firma registreret?',
    'EmployeeLocationText': 'Hvor er du registreret?',
    'selfEmployedText': 'Er du selvstændig?',
    'yes': 'Ja',
    'no': 'Nej',
    'lblNL': 'Holland',
    'lblNonNL': 'Andet land',
    'nationalityText': 'Vælg venligst din nationalitet',
    'exceptionSelectionText': 'Er dit besøg dækket af en af følgende undtagelser?',
    'durationSelectionText': 'Bliver du længere end 90 dage?',
    'scanningHelperText': 'Mere information',
    'nationalityPlaceholder': 'Nationalitet',
    'expiredError': 'Dokument udløbet eller vil udløbe for snart',
    'a1NationalityMismatch': 'Medlemsstaten på dit A1 (udstedelsesland) stemmer ikke overens med dit svar i det forrige trin. Gå tilbage til den forrige skærm og vælg det korrekte svar.',
  },
  'ES': {
    'welcomeTitle': 'Verificación de cumplimiento social',
    'welcomeReason': 'Para garantizar el cumplimiento social, necesitamos hacer algunas preguntas y validar algunos documentos.',
    'finishedTitle': 'Listo para enviar',
    'finishedReason': 'Al enviar, los datos proporcionados serán revisados cuidadosamente y podrían ser necesarias verificaciones adicionales.',
    'scanningTitle': 'Sube tus documentos',
    'scanningText': 'Captura o selecciona una imagen de tu documento donde los bordes sean visibles y todo el texto esté claramente legible.',
    'errorNotRecognised': 'Documento no reconocido',
    'errorWrongType': 'Esperábamos un archivo {expectedType} pero proporcionaste un {uploadedFileType}',
    'lblExpires': 'Vence',
    'lblUploadOrCapture': 'Sube o captura una imagen del documento solicitado',
    'lblVAT': 'IVA',
    'VATText': 'Por favor proporcione su número de IVA',
    'VATError': 'Este no es un número de IVA válido, asegúrese de ingresar un número de IVA correcto',
    'lblBE': 'Bélgica',
    'lblNonBE': 'Otro país',
    'lblEER': 'País del EEE (UE27 (incl. BE) / Islandia / Noruega / Liechtenstein / Suiza)',
    'lblNonEER': 'Otro país',
    'employeeDetailText': 'Por favor proporcione la siguiente información',
    'requestException': 'Quiero solicitar una excepción',
    'requestExceptionProofOfIndependence': 'No tengo prueba de independencia',
    'exceptionIntroLimosa': 'Si cumple con una de las siguientes excepciones, no necesita solicitar una Limosa.',
    'installationAndAssembly': 'Instalación y montaje (máx. 8 días)',
    'exceptionFirstDescriptionLimosa': 'Los trabajadores y autónomos enviados a Bélgica para el montaje y/o instalación inicial de mercancías están exentos. Esto se aplica solo a trabajadores cualificados y/o especializados en la empresa que suministra las mercancías, o al proveedor autónomo. <strong>El trabajo no puede exceder 8 días.</strong> Esta exención no se aplica al sector de la construcción.',
    'urgentRepairAndMaintenanceWork': 'Trabajos urgentes de reparación y mantenimiento (máx. 5 días)',
    'exceptionSecondDescriptionLimosa': 'Los técnicos especializados de empresas extranjeras y autónomos están exentos si vienen a Bélgica para realizar trabajos urgentes de mantenimiento o reparación en máquinas o equipos. Las máquinas o equipos deben haber sido entregados por su empleador o por los propios autónomos a la empresa donde tuvo lugar la reparación/mantenimiento. Dichos técnicos no pueden permanecer en suelo belga durante <strong>más de 5 días al mes</strong>.',
    'exceptionExtraInformation': 'Más información',
    'exceptionConfirmationIntro': 'Por la presente confirmo que cumplo con la siguiente regla de excepción:',
    'exceptionFrom': 'Desde',
    'exceptionTo': 'Hasta',
    'exceptionSignature': 'Firma',
    'exceptionIndependence': 'Por la presente confirmo que soy independiente según la ley belga:',
    'GroupSelectionText': '¿Para qué empresa está realizando esta tarea?',
    'CountryLocationText': '¿Dónde está registrada su empresa?',
    'EmployeeLocationText': '¿Dónde está registrado?',
    'selfEmployedText': '¿Es usted autónomo?',
    'yes': 'Sí',
    'no': 'No',
    'lblNL': 'Países Bajos',
    'lblNonNL': 'Otro país',
    'nationalityText': 'Por favor seleccione su nacionalidad',
    'exceptionSelectionText': '¿Está su visita cubierta por una de las siguientes excepciones?',
    'durationSelectionText': '¿Se quedará más de 90 días?',
    'scanningHelperText': 'Más información',
    'nationalityPlaceholder': 'Nacionalidad',
    'expiredError': 'Documento vencido o vencerá demasiado pronto',
    'a1NationalityMismatch': 'El Estado miembro en su A1 (país emisor) no corresponde con la respuesta proporcionada en el paso anterior. Vuelva a la pantalla anterior y seleccione la respuesta correcta.',
  },
  'FI': {
    'welcomeTitle': 'Sosiaalisen vaatimustenmukaisuuden tarkistus',
    'welcomeReason': 'Varmistaaksemme sosiaalisen vaatimustenmukaisuuden meidän on esitettävä joitakin kysymyksiä ja vahvistettava joitakin asiakirjoja.',
    'finishedTitle': 'Valmis lähettämään',
    'finishedReason': 'Lähettämisessä antamasi tiedot tarkistetaan huolellisesti ja lisätarkistukset voivat olla tarpeen.',
    'scanningTitle': 'Lataa asiakirjasi',
    'scanningText': 'Ota tai valitse kuva asiakirjastasi, jossa reunat ovat näkyvissä ja kaikki teksti on selkeästi luettavissa.',
    'errorNotRecognised': 'Asiakirjaa ei tunnistettu',
    'errorWrongType': 'Odotimme {expectedType} tiedostoa, mutta annoit {uploadedFileType}',
    'lblExpires': 'Vanhenee',
    'lblUploadOrCapture': 'Lataa tai ota kuva pyydetystä asiakirjasta',
    'lblVAT': 'ALV',
    'VATText': 'Anna ALV-numerosi',
    'VATError': 'Tämä ei ole kelvollinen ALV-numero, varmista että syötät oikean ALV-numeron',
    'lblBE': 'Belgia',
    'lblNonBE': 'Muu maa',
    'lblEER': 'ETA-maa (EU27 (sis. BE) / Islanti / Norja / Liechtenstein / Sveitsi)',
    'lblNonEER': 'Muu maa',
    'employeeDetailText': 'Anna seuraavat tiedot',
    'requestException': 'Haluan pyytää poikkeusta',
    'requestExceptionProofOfIndependence': 'Minulla ei ole todistetta itsenäisyydestä',
    'exceptionIntroLimosa': 'Jos täytät yhden seuraavista poikkeuksista, sinun ei tarvitse hakea Limosa.',
    'installationAndAssembly': 'Asennus ja kokoaminen (maks. 8 päivää)',
    'exceptionFirstDescriptionLimosa': 'Belgiaan lähetetyt työntekijät ja yrittäjät tavaroiden alkuperäiseen kokoamiseen ja/tai asentamiseen ovat vapautettuja. Tämä koskee vain päteviä ja/tai erikoistuneita työntekijöitä tavaroita toimittavassa yrityksessä tai itsenäistä toimittajaa. <strong>Työ ei saa ylittää 8 päivää.</strong> Tämä vapautus ei koske rakennussektoria.',
    'urgentRepairAndMaintenanceWork': 'Kiireelliset korjaus- ja huoltotyöt (maks. 5 päivää)',
    'exceptionSecondDescriptionLimosa': 'Ulkomaisten yritysten erikoistuneet teknikot ja yrittäjät ovat vapautettuja, jos he tulevat Belgiaan suorittamaan kiireellisiä huolto- tai korjaustöitä koneisiin tai laitteisiin. Koneet tai laitteet on toimitettava heidän työnantajansa tai yrittäjien itsensä toimittamana yritykseen, jossa korjaus/huolto tapahtui. Tällaiset teknikot eivät saa olla Belgian maaperällä <strong>yli 5 päivää kuukaudessa</strong>.',
    'exceptionExtraInformation': 'Lisätietoja',
    'exceptionConfirmationIntro': 'Vahvistan tällä, että täytän seuraavan poikkeussäännön:',
    'exceptionFrom': 'Alkaen',
    'exceptionTo': 'Päättyen',
    'exceptionSignature': 'Allekirjoitus',
    'exceptionIndependence': 'Vahvistan tällä, että olen itsenäinen Belgian lain mukaan:',
    'GroupSelectionText': 'Minkä yrityksen puolesta suoritat tämän tehtävän?',
    'CountryLocationText': 'Missä yrityksesi on rekisteröity?',
    'EmployeeLocationText': 'Missä olet rekisteröity?',
    'selfEmployedText': 'Oletko yrittäjä?',
    'yes': 'Kyllä',
    'no': 'Ei',
    'lblNL': 'Alankomaat',
    'lblNonNL': 'Muu maa',
    'nationalityText': 'Valitse kansallisuutesi',
    'exceptionSelectionText': 'Onko vierailusi yhden seuraavista poikkeuksista?',
    'durationSelectionText': 'Jäätkö yli 90 päiväksi?',
    'scanningHelperText': 'Lisätietoja',
    'nationalityPlaceholder': 'Kansallisuus',
    'expiredError': 'Asiakirja vanhentunut tai vanhenee liian pian',
    'a1NationalityMismatch': 'A1-lomakkeen jäsenvaltio (myöntäjämaa) ei vastaa edellisessä vaiheessa antamaasi vastausta. Palaa edelliselle näytölle ja valitse oikea vastaus.',
  },
  'HR': {
    'welcomeTitle': 'Provjera društvene usklađenosti',
    'welcomeReason': 'Kako bismo osigurali društvenu usklađenost, moramo postaviti neka pitanja i validirati neke dokumente.',
    'finishedTitle': 'Spremno za slanje',
    'finishedReason': 'Pri slanju će se podaci koje ste unijeli pažljivo pregledati i mogu biti potrebne dodatne provjere.',
    'scanningTitle': 'Učitajte svoje dokumente',
    'scanningText': 'Snimite ili odaberite sliku vašeg dokumenta gdje su rubovi vidljivi i sav tekst je jasno čitljiv.',
    'errorNotRecognised': 'Dokument nije prepoznat',
    'errorWrongType': 'Očekivali smo {expectedType} datoteku, ali ste dali {uploadedFileType}',
    'lblExpires': 'Istječe',
    'lblUploadOrCapture': 'Učitaj ili snimi sliku traženog dokumenta',
    'lblVAT': 'PDV',
    'VATText': 'Molimo navedite svoj OIB',
    'VATError': 'Ovo nije valjan OIB, molimo provjerite da unosite ispravan OIB',
    'lblBE': 'Belgija',
    'lblNonBE': 'Druga država',
    'lblEER': 'EEA država (EU27 (uklj. BE) / Island / Norveška / Lihtenštajn / Švicarska)',
    'lblNonEER': 'Druga država',
    'employeeDetailText': 'Molimo navedite sljedeće informacije',
    'requestException': 'Želim zatražiti iznimku',
    'requestExceptionProofOfIndependence': 'Nemam dokaz neovisnosti',
    'exceptionIntroLimosa': 'Ako ispunjavate jednu od sljedećih iznimki, ne trebate podnijeti zahtjev za Limosa.',
    'installationAndAssembly': 'Instalacija i montaža (maks. 8 dana)',
    'exceptionFirstDescriptionLimosa': 'Radnici i samozaposleni poslani u Belgiju za početnu montažu i/ili instalaciju robe su oslobođeni. To se odnosi samo na kvalificirane i/ili specijalizirane radnike u poduzeću koje isporučuje robu ili samostalnog dobavljača. <strong>Rad ne smije premašiti 8 dana.</strong> Ovo izuzeće ne odnosi se na građevinski sektor.',
    'urgentRepairAndMaintenanceWork': 'Hitni popravci i radovi na održavanju (maks. 5 dana)',
    'exceptionSecondDescriptionLimosa': 'Specijalizirani tehničari iz stranih tvrtki i samozaposleni su oslobođeni ako dolaze u Belgiju obavljati hitne radove na održavanju ili popravke strojeva ili opreme. Strojevi ili oprema moraju biti isporučeni od strane njihovog poslodavca ili od samih samozaposlenih u poduzeće gdje je popravka/održavanje obavljeno. Takvi tehničari ne smiju ostati na belgijskom tlu <strong>duže od 5 dana mjesečno</strong>.',
    'exceptionExtraInformation': 'Više informacija',
    'exceptionConfirmationIntro': 'Ovime potvrđujem da ispunjavam sljedeće pravilo iznimke:',
    'exceptionFrom': 'Od',
    'exceptionTo': 'Do',
    'exceptionSignature': 'Potpis',
    'exceptionIndependence': 'Ovime potvrđujem da sam neovisan prema belgijskom zakonu:',
    'GroupSelectionText': 'Za koju tvrtku obavljate ovaj zadatak?',
    'CountryLocationText': 'Gdje je vaša tvrtka registrirana?',
    'EmployeeLocationText': 'Gdje ste registrirani?',
    'selfEmployedText': 'Jeste li samozaposleni?',
    'yes': 'Da',
    'no': 'Ne',
    'lblNL': 'Nizozemska',
    'lblNonNL': 'Druga država',
    'nationalityText': 'Molimo odaberite svoju nacionalnost',
    'exceptionSelectionText': 'Je li vaš posjet pokriven jednom od sljedećih iznimki?',
    'durationSelectionText': 'Ostajete li duže od 90 dana?',
    'scanningHelperText': 'Više informacija',
    'nationalityPlaceholder': 'Nacionalnost',
    'expiredError': 'Dokument je istekao ili će uskoro isteći',
    'a1NationalityMismatch': 'Država članica na vašem A1 dokumentu (država izdavanja) ne odgovara vašem odgovoru iz prethodnog koraka. Vratite se na prethodni zaslon i odaberite točan odgovor.',
  },
  'HU': {
    'welcomeTitle': 'Társadalmi megfelelőségi ellenőrzés',
    'welcomeReason': 'A társadalmi megfelelőség biztosítása érdekében néhány kérdést kell feltennünk és néhány dokumentumot ellenőriznünk kell.',
    'finishedTitle': 'Kész az elküldésre',
    'finishedReason': 'Az elküldéskor a megadott adatokat gondosan átnézik, és további ellenőrzések szükségesek lehetnek.',
    'scanningTitle': 'Töltse fel dokumentumait',
    'scanningText': 'Készítsen vagy válasszon egy képet a dokumentumáról, ahol a szélek láthatók és az összes szöveg jól olvasható.',
    'errorNotRecognised': 'Dokumentum nem felismerhető',
    'errorWrongType': '{expectedType} fájlt vártunk, de Ön {uploadedFileType} fájlt adott meg',
    'lblExpires': 'Lejár',
    'lblUploadOrCapture': 'Töltse fel vagy készítsen képet a kért dokumentumról',
    'lblVAT': 'ÁFA',
    'VATText': 'Kérjük, adja meg az ÁFA-számát',
    'VATError': 'Ez nem érvényes ÁFA-szám, kérjük, győződjön meg róla, hogy helyes ÁFA-számot ad meg',
    'lblBE': 'Belgium',
    'lblNonBE': 'Másik ország',
    'lblEER': 'EGT ország (EU27 (BE-t is beleértve) / Izland / Norvégia / Liechtenstein / Svájc)',
    'lblNonEER': 'Másik ország',
    'employeeDetailText': 'Kérjük, adja meg a következő információkat',
    'requestException': 'Kivételt szeretnék kérni',
    'requestExceptionProofOfIndependence': 'Nincs bizonyítékom a függetlenségről',
    'exceptionIntroLimosa': 'Ha az alábbi kivételek egyikének megfelel, nem kell Limosa kérelmet benyújtania.',
    'installationAndAssembly': 'Telepítés és összeszerelés (max. 8 nap)',
    'exceptionFirstDescriptionLimosa': 'A munkavállalók és az egyéni vállalkozók, akiket Belgiumba küldenek az áruk kezdeti összeszerelésére és/vagy telepítésére, mentesülnek. Ez csak a javakat szállító vállalkozásban dolgozó képzett és/vagy szakemberekre vagy a független szállítóra vonatkozik. <strong>A munka nem haladhatja meg a 8 napot.</strong> Ez a mentesség nem vonatkozik az építőipari szektorra.',
    'urgentRepairAndMaintenanceWork': 'Sürgős javítási és karbantartási munkák (max. 5 nap)',
    'exceptionSecondDescriptionLimosa': 'A külföldi vállalatok szakemberei és az egyéni vállalkozók mentesülnek, ha Belgiumba jönnek gépek vagy berendezések sürgős karbantartását vagy javítását végezni. A gépeket vagy berendezéseket munkáltatójuknak vagy az egyéni vállalkozóknak maguknak kellett szállítaniuk az üzlethez, ahol a javítás/karbantartás történt. Az ilyen technikusok <strong>nem maradhatnak belga területen hónaponta 5 napnál hosszabb ideig</strong>.',
    'exceptionExtraInformation': 'További információk',
    'exceptionConfirmationIntro': 'Jelenleg megerősítem, hogy megfelelek a következő kivételi szabálynak:',
    'exceptionFrom': 'Tól',
    'exceptionTo': 'Ig',
    'exceptionSignature': 'Aláírás',
    'exceptionIndependence': 'Jelenleg megerősítem, hogy belga törvény szerint független vagyok:',
    'GroupSelectionText': 'Melyik vállalatnak végezi ezt a feladatot?',
    'CountryLocationText': 'Hol van a vállalkozása bejegyezve?',
    'EmployeeLocationText': 'Hol van bejegyezve?',
    'selfEmployedText': 'Ön vállalkozó?',
    'yes': 'Igen',
    'no': 'Nem',
    'lblNL': 'Hollandia',
    'lblNonNL': 'Másik ország',
    'nationalityText': 'Kérjük, válassza ki nemzetiségét',
    'exceptionSelectionText': 'A látogatása az alábbi kivételek egyikébe tartozik?',
    'durationSelectionText': 'Több mint 90 napig marad?',
    'scanningHelperText': 'További információk',
    'nationalityPlaceholder': 'Nemzetiség',
    'expiredError': 'A dokumentum lejárt vagy túl hamar fog lejárni',
    'a1NationalityMismatch': 'Az A1 igazoláson szereplő tagállam (kiállító ország) nem egyezik az előző lépésben megadott válaszával. Lépjen vissza az előző képernyőre és válassza ki a helyes választ.',
  },
  'IT': {
    'welcomeTitle': 'Verifica della conformità sociale',
    'welcomeReason': 'Per garantire la conformità sociale, dobbiamo porre alcune domande e far validare alcuni documenti.',
    'finishedTitle': 'Pronto per l\'invio',
    'finishedReason': 'All\'invio, i dati forniti saranno attentamente revisionati e potrebbero essere necessarie verifiche aggiuntive.',
    'scanningTitle': 'Carica i tuoi documenti',
    'scanningText': 'Cattura o seleziona un\'immagine del tuo documento dove i bordi sono visibili e tutto il testo è chiaramente leggibile.',
    'errorNotRecognised': 'Documento non riconosciuto',
    'errorWrongType': 'Ci aspettavamo un file {expectedType} ma hai fornito un {uploadedFileType}',
    'lblExpires': 'Scade',
    'lblUploadOrCapture': 'Carica o cattura un\'immagine del documento richiesto',
    'lblVAT': 'IVA',
    'VATText': 'Si prega di fornire la propria partita IVA',
    'VATError': 'Questo non è un numero di partita IVA valido, assicurati di inserire un numero di partita IVA corretto',
    'lblBE': 'Belgio',
    'lblNonBE': 'Altro paese',
    'lblEER': 'Paese SEE (UE27 (incl. BE) / Islanda / Norvegia / Liechtenstein / Svizzera)',
    'lblNonEER': 'Altro paese',
    'employeeDetailText': 'Si prega di fornire le seguenti informazioni',
    'requestException': 'Voglio richiedere un\'eccezione',
    'requestExceptionProofOfIndependence': 'Non ho prova di indipendenza',
    'exceptionIntroLimosa': 'Se rispetti una delle seguenti eccezioni, non è necessario richiedere una Limosa.',
    'installationAndAssembly': 'Installazione e montaggio (max. 8 giorni)',
    'exceptionFirstDescriptionLimosa': 'I lavoratori e i lavoratori autonomi inviati in Belgio per il montaggio e/o l\'installazione iniziale delle merci sono esenti. Questo si applica solo ai lavoratori qualificati e/o specializzati nell\'azienda che fornisce le merci, o al fornitore autonomo. <strong>Il lavoro non può superare gli 8 giorni.</strong> Questa esenzione non si applica al settore delle costruzioni.',
    'urgentRepairAndMaintenanceWork': 'Lavori urgenti di riparazione e manutenzione (max. 5 giorni)',
    'exceptionSecondDescriptionLimosa': 'I tecnici specializzati di aziende straniere e i lavoratori autonomi sono esenti se vengono in Belgio per eseguire lavori urgenti di manutenzione o riparazione su macchine o attrezzature. Le macchine o le attrezzature devono essere state consegnate dal loro datore di lavoro o dai lavoratori autonomi stessi all\'azienda dove ha avuto luogo la riparazione/manutenzione. Tali tecnici non possono rimanere su suolo belga per <strong>più di 5 giorni al mese</strong>.',
    'exceptionExtraInformation': 'Ulteriori informazioni',
    'exceptionConfirmationIntro': 'Con la presente confermo di rispettare la seguente regola di eccezione:',
    'exceptionFrom': 'Da',
    'exceptionTo': 'A',
    'exceptionSignature': 'Firma',
    'exceptionIndependence': 'Con la presente confermo di essere indipendente secondo la legge belga:',
    'GroupSelectionText': 'Per quale azienda stai eseguendo questo compito?',
    'CountryLocationText': 'Dove è registrata la tua azienda?',
    'EmployeeLocationText': 'Dove sei registrato?',
    'selfEmployedText': 'Sei un lavoratore autonomo?',
    'yes': 'Sì',
    'no': 'No',
    'lblNL': 'Paesi Bassi',
    'lblNonNL': 'Altro paese',
    'nationalityText': 'Si prega di selezionare la propria nazionalità',
    'exceptionSelectionText': 'La tua visita è coperta da una delle seguenti eccezioni?',
    'durationSelectionText': 'Rimani più di 90 giorni?',
    'scanningHelperText': 'Ulteriori informazioni',
    'nationalityPlaceholder': 'Nazionalità',
    'expiredError': 'Documento scaduto o scadrà troppo presto',
    'a1NationalityMismatch': 'Lo Stato membro sul vostro A1 (paese di rilascio) non corrisponde alla risposta fornita nel passaggio precedente. Tornate alla schermata precedente e selezionate la risposta corretta.',
  },
  'NO': {
    'welcomeTitle': 'Kontroll av sosial overholdelse',
    'welcomeReason': 'For å sikre sosial overholdelse må vi stille noen spørsmål og få validert noen dokumenter.',
    'finishedTitle': 'Klar til innsending',
    'finishedReason': 'Ved innsending vil dataene du har oppgitt bli nøye gjennomgått, og det kan være behov for ytterligere kontroller.',
    'scanningTitle': 'Last opp dokumentene dine',
    'scanningText': 'Ta eller velg et bilde av dokumentet ditt hvor kantene er synlige og all tekst er tydelig lesbar.',
    'errorNotRecognised': 'Dokument ikke gjenkjent',
    'errorWrongType': 'Vi forventet en {expectedType} fil, men du leverte en {uploadedFileType}',
    'lblExpires': 'Utløper',
    'lblUploadOrCapture': 'Last opp eller ta et bilde av det forespurte dokumentet',
    'lblVAT': 'MVA',
    'VATText': 'Angi vennligst ditt MVA-nummer',
    'VATError': 'Dette er ikke et gyldig MVA-nummer, sørg for at du oppgir et korrekt MVA-nummer',
    'lblBE': 'Belgia',
    'lblNonBE': 'Annet land',
    'lblEER': 'EØS-land (EU27 (inkl. BE) / Island / Norge / Liechtenstein / Sveits)',
    'lblNonEER': 'Annet land',
    'employeeDetailText': 'Oppgi følgende informasjon',
    'requestException': 'Jeg vil be om et unntak',
    'requestExceptionProofOfIndependence': 'Jeg har ikke bevis på selvstendighet',
    'exceptionIntroLimosa': 'Hvis du overholder et av følgende unntak, trenger du ikke å søke om Limosa.',
    'installationAndAssembly': 'Installasjon og montering (maks. 8 dager)',
    'exceptionFirstDescriptionLimosa': 'Arbeidere og selvstendig næringsdrivende sendt til Belgia for den første monteringen og/eller installasjonen av varer er fritatt. Dette gjelder bare for kvalifiserte og/eller spesialiserte arbeidere i virksomheten som leverer varene, eller den selvstendige leverandøren. <strong>Arbeidet kan ikke overstige 8 dager.</strong> Dette unntaket gjelder ikke for byggebransjen.',
    'urgentRepairAndMaintenanceWork': 'Hastereparasjoner og vedlikeholdsarbeid (maks. 5 dager)',
    'exceptionSecondDescriptionLimosa': 'Spesialiserte teknikere fra utenlandske selskaper og selvstendig næringsdrivende er fritatt hvis de kommer til Belgia for å utføre hastereparasjoner eller vedlikeholdsarbeid på maskiner eller utstyr. Maskiner eller utstyr må ha blitt levert av arbeidsgiveren deres eller av de selvstendig næringsdrivende selv til virksomheten hvor reparasjonen/vedlikeholdet fant sted. Slike teknikere kan ikke oppholde seg på belgisk jord i <strong>mer enn 5 dager per måned</strong>.',
    'exceptionExtraInformation': 'Mer informasjon',
    'exceptionConfirmationIntro': 'Jeg bekrefter herved at jeg overholder følgende unntaksregel:',
    'exceptionFrom': 'Fra',
    'exceptionTo': 'Til',
    'exceptionSignature': 'Signatur',
    'exceptionIndependence': 'Jeg bekrefter herved at jeg er selvstendig i henhold til belgisk lov:',
    'GroupSelectionText': 'For hvilket firma utfører du denne oppgaven?',
    'CountryLocationText': 'Hvor er firmaet ditt registrert?',
    'EmployeeLocationText': 'Hvor er du registrert?',
    'selfEmployedText': 'Er du selvstendig næringsdrivende?',
    'yes': 'Ja',
    'no': 'Nei',
    'lblNL': 'Nederland',
    'lblNonNL': 'Annet land',
    'nationalityText': 'Velg din nasjonalitet',
    'exceptionSelectionText': 'Er besøket ditt dekket av et av følgende unntak?',
    'durationSelectionText': 'Blir du lenger enn 90 dager?',
    'scanningHelperText': 'Mer informasjon',
    'nationalityPlaceholder': 'Nasjonalitet',
    'expiredError': 'Dokument utløpt eller vil utløpe for snart',
    'a1NationalityMismatch': 'Medlemsstaten på A1-dokumentet ditt (utstedelsesland) samsvarer ikke med svaret du ga i forrige trinn. Gå tilbake til forrige skjerm og velg riktig svar.',
  },
  'PT': {
    'welcomeTitle': 'Verificação de conformidade social',
    'welcomeReason': 'Para garantir a conformidade social, precisamos fazer algumas perguntas e validar alguns documentos.',
    'finishedTitle': 'Pronto para enviar',
    'finishedReason': 'Ao enviar, os dados fornecidos serão cuidadosamente revisados e verificações adicionais poderão ser necessárias.',
    'scanningTitle': 'Faça upload dos seus documentos',
    'scanningText': 'Capture ou selecione uma imagem do seu documento onde as bordas estão visíveis e todo o texto está claramente legível.',
    'errorNotRecognised': 'Documento não reconhecido',
    'errorWrongType': 'Esperávamos um arquivo {expectedType} mas você forneceu um {uploadedFileType}',
    'lblExpires': 'Expira',
    'lblUploadOrCapture': 'Carregue ou capture uma imagem do documento solicitado',
    'lblVAT': 'IVA',
    'VATText': 'Por favor forneça seu número de IVA',
    'VATError': 'Este não é um número de IVA válido, certifique-se de inserir um número de IVA correto',
    'lblBE': 'Bélgica',
    'lblNonBE': 'Outro país',
    'lblEER': 'País do EEE (UE27 (incl. BE) / Islândia / Noruega / Liechtenstein / Suíça)',
    'lblNonEER': 'Outro país',
    'employeeDetailText': 'Por favor forneça as seguintes informações',
    'requestException': 'Quero solicitar uma exceção',
    'requestExceptionProofOfIndependence': 'Não tenho prova de independência',
    'exceptionIntroLimosa': 'Se você cumpre uma das seguintes exceções, não precisa solicitar uma Limosa.',
    'installationAndAssembly': 'Instalação e montagem (máx. 8 dias)',
    'exceptionFirstDescriptionLimosa': 'Trabalhadores e autônomos enviados para a Bélgica para a montagem e/ou instalação inicial de mercadorias estão isentos. Isso se aplica apenas a trabalhadores qualificados e/ou especializados na empresa que fornece as mercadorias, ou ao fornecedor autônomo. <strong>O trabalho não pode exceder 8 dias.</strong> Esta isenção não se aplica ao setor da construção.',
    'urgentRepairAndMaintenanceWork': 'Trabalhos urgentes de reparo e manutenção (máx. 5 dias)',
    'exceptionSecondDescriptionLimosa': 'Técnicos especializados de empresas estrangeiras e autônomos estão isentos se vierem para a Bélgica para realizar trabalhos urgentes de manutenção ou reparo em máquinas ou equipamentos. As máquinas ou equipamentos devem ter sido entregues por seu empregador ou pelos próprios autônomos à empresa onde o reparo/manutenção ocorreu. Tais técnicos não podem permanecer em solo belga por <strong>mais de 5 dias por mês</strong>.',
    'exceptionExtraInformation': 'Mais informações',
    'exceptionConfirmationIntro': 'Por meio deste confirmo que cumpro a seguinte regra de exceção:',
    'exceptionFrom': 'De',
    'exceptionTo': 'Até',
    'exceptionSignature': 'Assinatura',
    'exceptionIndependence': 'Por meio deste confirmo que sou independente de acordo com a lei belga:',
    'GroupSelectionText': 'Para qual empresa você está realizando esta tarefa?',
    'CountryLocationText': 'Onde sua empresa está registrada?',
    'EmployeeLocationText': 'Onde você está registrado?',
    'selfEmployedText': 'Você é trabalhador autônomo?',
    'yes': 'Sim',
    'no': 'Não',
    'lblNL': 'Países Baixos',
    'lblNonNL': 'Outro país',
    'nationalityText': 'Por favor selecione sua nacionalidade',
    'exceptionSelectionText': 'Sua visita está coberta por uma das seguintes exceções?',
    'durationSelectionText': 'Você ficará mais de 90 dias?',
    'scanningHelperText': 'Mais informações',
    'nationalityPlaceholder': 'Nacionalidade',
    'expiredError': 'Documento expirado ou expirará muito em breve',
    'a1NationalityMismatch': 'O Estado-Membro no seu A1 (país emissor) não corresponde à resposta fornecida no passo anterior. Volte ao ecrã anterior e selecione a resposta correta.',
  },
  'RO': {
    'welcomeTitle': 'Verificare conformitate socială',
    'welcomeReason': 'Pentru a asigura conformitatea socială, trebuie să punem câteva întrebări și să validăm unele documente.',
    'finishedTitle': 'Gata de trimis',
    'finishedReason': 'La trimitere, datele furnizate vor fi examinate cu atenție și pot fi necesare verificări suplimentare.',
    'scanningTitle': 'Încărcați documentele',
    'scanningText': 'Captați sau selectați o imagine a documentului dvs. unde marginile sunt vizibile și tot textul este clar lizibil.',
    'errorNotRecognised': 'Document nerecunoscut',
    'errorWrongType': 'Ne așteptam la un fișier {expectedType} dar ați furnizat un {uploadedFileType}',
    'lblExpires': 'Expiră',
    'lblUploadOrCapture': 'Încărcați sau captați o imagine a documentului solicitat',
    'lblVAT': 'TVA',
    'VATText': 'Vă rugăm să furnizați numărul dvs. de TVA',
    'VATError': 'Acesta nu este un număr de TVA valid, vă rugăm să vă asigurați că introduceți un număr de TVA corect',
    'lblBE': 'Belgia',
    'lblNonBE': 'Altă țară',
    'lblEER': 'Țară EEA (UE27 (incl. BE) / Islanda / Norvegia / Liechtenstein / Elveția)',
    'lblNonEER': 'Altă țară',
    'employeeDetailText': 'Vă rugăm să furnizați următoarele informații',
    'requestException': 'Vreau să solicit o excepție',
    'requestExceptionProofOfIndependence': 'Nu am dovadă de independență',
    'exceptionIntroLimosa': 'Dacă respectați una dintre următoarele excepții, nu trebuie să solicitați o Limosa.',
    'installationAndAssembly': 'Instalare și asamblare (max. 8 zile)',
    'exceptionFirstDescriptionLimosa': 'Lucrătorii și persoanele fizice autorizate trimise în Belgia pentru asamblarea și/sau instalarea inițială a mărfurilor sunt scutiți. Acest lucru se aplică doar lucrătorilor calificați și/sau specializați din întreprinderea care furnizează mărfurile sau furnizorului persoană fizică autorizată. <strong>Lucrarea nu poate depăși 8 zile.</strong> Această scutire nu se aplică sectorului construcțiilor.',
    'urgentRepairAndMaintenanceWork': 'Lucrări urgente de reparație și întreținere (max. 5 zile)',
    'exceptionSecondDescriptionLimosa': 'Tehnicienii specializați din companiile străine și persoanele fizice autorizate sunt scutiți dacă vin în Belgia pentru a efectua lucrări urgente de întreținere sau reparație la mașini sau echipamente. Mașinile sau echipamentele trebuie să fi fost livrate de către angajatorul lor sau de către persoanele fizice autorizate înșile către întreprinderea unde a avut loc reparația/întreținerea. Astfel de tehnicieni nu pot rămâne pe teritoriul belgian <strong>mai mult de 5 zile pe lună</strong>.',
    'exceptionExtraInformation': 'Mai multe informații',
    'exceptionConfirmationIntro': 'Prin prezenta confirm că respect următoarea regulă de excepție:',
    'exceptionFrom': 'De la',
    'exceptionTo': 'Până la',
    'exceptionSignature': 'Semnătură',
    'exceptionIndependence': 'Prin prezenta confirm că sunt persoană fizică autorizată conform legii belgiene:',
    'GroupSelectionText': 'Pentru ce companie efectuați această sarcină?',
    'CountryLocationText': 'Unde este înregistrată compania dvs.?',
    'EmployeeLocationText': 'Unde sunteți înregistrat?',
    'selfEmployedText': 'Sunteți persoană fizică autorizată?',
    'yes': 'Da',
    'no': 'Nu',
    'lblNL': 'Țările de Jos',
    'lblNonNL': 'Altă țară',
    'nationalityText': 'Vă rugăm să selectați naționalitatea dvs.',
    'exceptionSelectionText': 'Este vizita dvs. acoperită de una dintre următoarele excepții?',
    'durationSelectionText': 'Rămâneți mai mult de 90 de zile?',
    'scanningHelperText': 'Mai multe informații',
    'nationalityPlaceholder': 'Naționalitate',
    'expiredError': 'Document expirat sau va expira prea curând',
    'a1NationalityMismatch': 'Statul membru de pe A1 (țara emitentă) nu corespunde cu răspunsul furnizat în pasul anterior. Reveniți la ecranul anterior și selectați răspunsul corect.',
  },
  'RU': {
    'welcomeTitle': 'Проверка социального соответствия',
    'welcomeReason': 'Для обеспечения социального соответствия нам нужно задать несколько вопросов и проверить некоторые документы.',
    'finishedTitle': 'Готово к отправке',
    'finishedReason': 'При отправке предоставленные данные будут тщательно проверены, и могут потребоваться дополнительные проверки.',
    'scanningTitle': 'Загрузите ваши документы',
    'scanningText': 'Сделайте или выберите изображение вашего документа, где края видны и весь текст четко читаем.',
    'errorNotRecognised': 'Документ не распознан',
    'errorWrongType': 'Мы ожидали файл {expectedType}, но вы предоставили {uploadedFileType}',
    'lblExpires': 'Истекает',
    'lblUploadOrCapture': 'Загрузите или сделайте изображение запрошенного документа',
    'lblVAT': 'НДС',
    'VATText': 'Пожалуйста, укажите ваш номер НДС',
    'VATError': 'Это недействительный номер НДС, пожалуйста, убедитесь, что вы вводите правильный номер НДС',
    'lblBE': 'Бельгия',
    'lblNonBE': 'Другая страна',
    'lblEER': 'Страна ЕЭП (ЕС27 (включ. BE) / Исландия / Норвегия / Лихтенштейн / Швейцария)',
    'lblNonEER': 'Другая страна',
    'employeeDetailText': 'Пожалуйста, предоставьте следующую информацию',
    'requestException': 'Я хочу запросить исключение',
    'requestExceptionProofOfIndependence': 'У меня нет доказательства независимости',
    'exceptionIntroLimosa': 'Если вы соответствуете одному из следующих исключений, вам не нужно подавать заявку на Limosa.',
    'installationAndAssembly': 'Установка и сборка (макс. 8 дней)',
    'exceptionFirstDescriptionLimosa': 'Рабочие и самозанятые, отправленные в Бельгию для первоначальной сборки и/или установки товаров, освобождены. Это применяется только к квалифицированным и/или специализированным рабочим в компании, поставляющей товары, или к самозанятому поставщику. <strong>Работа не может превышать 8 дней.</strong> Это исключение не применяется к строительному сектору.',
    'urgentRepairAndMaintenanceWork': 'Срочные ремонтные и обслуживающие работы (макс. 5 дней)',
    'exceptionSecondDescriptionLimosa': 'Специализированные техники из иностранных компаний и самозанятые освобождены, если они приезжают в Бельгию для выполнения срочных работ по обслуживанию или ремонту машин или оборудования. Машины или оборудование должны были быть доставлены их работодателем или самими самозанятыми в компанию, где проводился ремонт/обслуживание. Такие техники не могут оставаться на бельгийской территории <strong>более 5 дней в месяц</strong>.',
    'exceptionExtraInformation': 'Больше информации',
    'exceptionConfirmationIntro': 'Настоящим подтверждаю, что я соблюдаю следующее правило исключения:',
    'exceptionFrom': 'С',
    'exceptionTo': 'До',
    'exceptionSignature': 'Подпись',
    'exceptionIndependence': 'Настоящим подтверждаю, что я независимый согласно бельгийскому законодательству:',
    'GroupSelectionText': 'Для какой компании вы выполняете эту задачу?',
    'CountryLocationText': 'Где зарегистрирована ваша компания?',
    'EmployeeLocationText': 'Где вы зарегистрированы?',
    'selfEmployedText': 'Вы самозанятый?',
    'yes': 'Да',
    'no': 'Нет',
    'lblNL': 'Нидерланды',
    'lblNonNL': 'Другая страна',
    'nationalityText': 'Пожалуйста, выберите вашу национальность',
    'exceptionSelectionText': 'Покрыт ли ваш визит одним из следующих исключений?',
    'durationSelectionText': 'Остаетесь ли вы дольше 90 дней?',
    'scanningHelperText': 'Больше информации',
    'nationalityPlaceholder': 'Национальность',
    'expiredError': 'Документ истек или скоро истечет',
    'a1NationalityMismatch': 'Государство-член на вашем A1 (страна выдачи) не соответствует ответу, предоставленному на предыдущем шаге. Вернитесь на предыдущий экран и выберите правильный ответ.',
  },
  'SK': {
    'welcomeTitle': 'Kontrola sociálnej zhody',
    'welcomeReason': 'Aby sme zabezpečili sociálnu zhodu, musíme položiť niekoľko otázok a nechať overiť niektoré dokumenty.',
    'finishedTitle': 'Pripravené na odoslanie',
    'finishedReason': 'Pri odosielaní budú poskytnuté údaje starostlivo skontrolované a môžu byť potrebné ďalšie kontroly.',
    'scanningTitle': 'Nahrajte svoje dokumenty',
    'scanningText': 'Zhotovte alebo vyberte obrázok dokumentu, kde sú okraje viditeľné a všetok text je jasne čitateľný.',
    'errorNotRecognised': 'Dokument nebol rozpoznaný',
    'errorWrongType': 'Očakávali sme súbor {expectedType}, ale poskytli ste {uploadedFileType}',
    'lblExpires': 'Vyprší',
    'lblUploadOrCapture': 'Nahrajte alebo urobte obrázok požadovaného dokumentu',
    'lblVAT': 'DPH',
    'VATText': 'Uveďte prosím svoje IČ DPH',
    'VATError': 'Toto nie je platné IČ DPH, uistite sa, že zadávate správne IČ DPH',
    'lblBE': 'Belgicko',
    'lblNonBE': 'Iná krajina',
    'lblEER': 'EHP krajina (EU27 (vrátane BE) / Island / Nórsko / Lichtenštajnsko / Švajčiarsko)',
    'lblNonEER': 'Iná krajina',
    'employeeDetailText': 'Uveďte prosím nasledujúce informácie',
    'requestException': 'Chcem požiadať o výnimku',
    'requestExceptionProofOfIndependence': 'Nemám dôkaz nezávislosti',
    'exceptionIntroLimosa': 'Ak spĺňate jednu z nasledujúcich výnimok, nemusíte žiadať o Limosa.',
    'installationAndAssembly': 'Inštalácia a montáž (max. 8 dní)',
    'exceptionFirstDescriptionLimosa': 'Pracovníci a SZČO vyslaní do Belgicka na počiatočnú montáž a/alebo inštaláciu tovaru sú oslobodení. Toto sa vzťahuje len na kvalifikovaných a/alebo špecializovaných pracovníkov v podniku dodávajúcom tovar alebo samostatného dodávateľa. <strong>Práca nesmie prekročiť 8 dní.</strong> Toto oslobodenie sa nevzťahuje na stavebný sektor.',
    'urgentRepairAndMaintenanceWork': 'Naliehavé opravy a údržba (max. 5 dní)',
    'exceptionSecondDescriptionLimosa': 'Špecializovaní technici zo zahraničných spoločností a SZČO sú oslobodení, ak prichádzajú do Belgicka vykonávať naliehavé údržbárske alebo opravárenské práce na strojoch alebo zariadeniach. Stroje alebo zariadenia museli byť dodané ich zamestnávateľom alebo samotnými SZČO do podniku, kde sa oprava/údržba uskutočnila. Takíto technici nesmú zostať na belgickom území <strong>dlhšie ako 5 dní mesačne</strong>.',
    'exceptionExtraInformation': 'Viac informácií',
    'exceptionConfirmationIntro': 'Týmto potvrdzujem, že spĺňam nasledujúcu výnimku:',
    'exceptionFrom': 'Od',
    'exceptionTo': 'Do',
    'exceptionSignature': 'Podpis',
    'exceptionIndependence': 'Týmto potvrdzujem, že som nezávislý podľa belgického práva:',
    'GroupSelectionText': 'Pre akú spoločnosť vykonávate túto úlohu?',
    'CountryLocationText': 'Kde je vaša spoločnosť registrovaná?',
    'EmployeeLocationText': 'Kde ste registrovaní?',
    'selfEmployedText': 'Ste SZČO?',
    'yes': 'Áno',
    'no': 'Nie',
    'lblNL': 'Holandsko',
    'lblNonNL': 'Iná krajina',
    'nationalityText': 'Vyberte prosím svoju národnosť',
    'exceptionSelectionText': 'Je vaša návšteva pokrytá jednou z nasledujúcich výnimok?',
    'durationSelectionText': 'Zostávate dlhšie ako 90 dní?',
    'scanningHelperText': 'Viac informácií',
    'nationalityPlaceholder': 'Národnosť',
    'expiredError': 'Dokument vypršal alebo vyprší príliš skoro',
    'a1NationalityMismatch': 'Členský štát na vašom A1 (vydávajúca krajina) nezodpovedá vašej odpovedi z predchádzajúceho kroku. Vráťte sa na predchádzajúcu obrazovku a vyberte správnu odpoveď.',
  },
  'SI': {
    'welcomeTitle': 'Preverjanje socialne skladnosti',
    'welcomeReason': 'Za zagotovitev socialne skladnosti moramo postaviti nekaj vprašanj in validirati nekatere dokumente.',
    'finishedTitle': 'Pripravljeno za oddajo',
    'finishedReason': 'Ob oddaji bodo podani podatki skrbno pregledani in morda bodo potrebne dodatne preveritve.',
    'scanningTitle': 'Naložite svoje dokumente',
    'scanningText': 'Ustvarite ali izberite sliko dokumenta, kjer so robovi vidni in ves tekst jasno berljiv.',
    'errorNotRecognised': 'Dokument ni prepoznan',
    'errorWrongType': 'Pričakovali smo datoteko {expectedType}, vendar ste podali {uploadedFileType}',
    'lblExpires': 'Izteče',
    'lblUploadOrCapture': 'Naložite ali naredite sliko zahtevanega dokumenta',
    'lblVAT': 'DDV',
    'VATText': 'Prosimo, navedite svoj ID za DDV',
    'VATError': 'To ni veljaven ID za DDV, prosimo poskrbite, da vnesete pravilen ID za DDV',
    'lblBE': 'Belgija',
    'lblNonBE': 'Druga država',
    'lblEER': 'Država EGP (EU27 (vklj. BE) / Islandija / Norveška / Lihtenštajn / Švica)',
    'lblNonEER': 'Druga država',
    'employeeDetailText': 'Prosimo, navedite naslednje informacije',
    'requestException': 'Želim zahtevati izjemo',
    'requestExceptionProofOfIndependence': 'Nimam dokazila neodvisnosti',
    'exceptionIntroLimosa': 'Če izpolnjujete eno od naslednjih izjem, vam ni treba zaprositi za Limosa.',
    'installationAndAssembly': 'Namestitev in montaža (maks. 8 dni)',
    'exceptionFirstDescriptionLimosa': 'Delavci in samostojni podjetniki poslani v Belgijo za začetno montažo in/ali namestitev blaga so oproščeni. To velja samo za usposobljene in/ali specializirane delavce v podjetju, ki dobavlja blago, ali samostojnega dobavitelja. <strong>Delo ne sme presegati 8 dni.</strong> Ta izjema ne velja za gradbeni sektor.',
    'urgentRepairAndMaintenanceWork': 'Nujna popravila in vzdrževalna dela (maks. 5 dni)',
    'exceptionSecondDescriptionLimosa': 'Specializirani tehniki iz tujih podjetij in samostojni podjetniki so oproščeni, če pridejo v Belgijo izvajati nujna vzdrževalna ali popravilna dela na strojih ali opremi. Stroji ali oprema morajo biti dostavljeni s strani njihovega delodajalca ali samih samostojnih podjetnikov v podjetje, kjer je potekalo popravilo/vzdrževanje. Takšni tehniki ne smejo ostati na belgijskem ozemlju <strong>dlje kot 5 dni na mesec</strong>.',
    'exceptionExtraInformation': 'Več informacij',
    'exceptionConfirmationIntro': 'S tem potrjujem, da izpolnjujem naslednje pravilo izjeme:',
    'exceptionFrom': 'Od',
    'exceptionTo': 'Do',
    'exceptionSignature': 'Podpis',
    'exceptionIndependence': 'S tem potrjujem, da sem neodvisen v skladu z belgijskim zakonom:',
    'GroupSelectionText': 'Za katero podjetje izvajate to nalogo?',
    'CountryLocationText': 'Kje je registrirano vaše podjetje?',
    'EmployeeLocationText': 'Kje ste registrirani?',
    'selfEmployedText': 'Ste samostojni podjetnik?',
    'yes': 'Da',
    'no': 'Ne',
    'lblNL': 'Nizozemska',
    'lblNonNL': 'Druga država',
    'nationalityText': 'Prosimo, izberite svojo narodnost',
    'exceptionSelectionText': 'Je vaš obisk pokrit z eno od naslednjih izjem?',
    'durationSelectionText': 'Ostajate dlje kot 90 dni?',
    'scanningHelperText': 'Več informacij',
    'nationalityPlaceholder': 'Narodnost',
    'expiredError': 'Dokument je potekel ali bo kmalu potekel',
    'a1NationalityMismatch': 'Država članica na vašem A1 (država izdaje) ne ustreza odgovoru, ki ste ga podali v prejšnjem koraku. Vrnite se na prejšnji zaslon in izberite pravilen odgovor.',
  },
  'SV': {
    'welcomeTitle': 'Kontroll av social överensstämmelse',
    'welcomeReason': 'För att säkerställa social överensstämmelse måste vi ställa några frågor och få validerade vissa dokument.',
    'finishedTitle': 'Redo att skicka',
    'finishedReason': 'Vid skickande kommer de uppgifter du har angett att noggrant granskas och ytterligare kontroller kan vara nödvändiga.',
    'scanningTitle': 'Ladda upp dina dokument',
    'scanningText': 'Fånga eller välj en bild av ditt dokument där kanterna är synliga och all text är tydligt läsbar.',
    'errorNotRecognised': 'Dokument inte igenkänt',
    'errorWrongType': 'Vi förväntade oss en {expectedType} fil men du angav en {uploadedFileType}',
    'lblExpires': 'Förfaller',
    'lblUploadOrCapture': 'Ladda upp eller fånga en bild av det begärda dokumentet',
    'lblVAT': 'Moms',
    'VATText': 'Ange ditt momsregistreringsnummer',
    'VATError': 'Detta är inte ett giltigt momsregistreringsnummer, se till att du anger ett korrekt momsregistreringsnummer',
    'lblBE': 'Belgien',
    'lblNonBE': 'Annan nation',
    'lblEER': 'EES-land (EU27 (inkl. BE) / Island / Norge / Liechtenstein / Schweiz)',
    'lblNonEER': 'Annan nation',
    'employeeDetailText': 'Ange följande information',
    'requestException': 'Jag vill begära ett undantag',
    'requestExceptionProofOfIndependence': 'Jag har inget bevis på självständighet',
    'exceptionIntroLimosa': 'Om du uppfyller ett av följande undantag behöver du inte ansöka om Limosa.',
    'installationAndAssembly': 'Installation och montering (max. 8 dagar)',
    'exceptionFirstDescriptionLimosa': 'Arbetare och egenföretagare som skickas till Belgien för den första monteringen och/eller installationen av varor är undantagna. Detta gäller endast kvalificerade och/eller specialiserade arbetare i företaget som levererar varorna, eller den självständiga leverantören. <strong>Arbetet får inte överskrida 8 dagar.</strong> Detta undantag gäller inte byggsektorn.',
    'urgentRepairAndMaintenanceWork': 'Akuta reparationer och underhållsarbeten (max. 5 dagar)',
    'exceptionSecondDescriptionLimosa': 'Specialiserade tekniker från utländska företag och egenföretagare är undantagna om de kommer till Belgien för att utföra akuta underhålls- eller reparationsarbeten på maskiner eller utrustning. Maskinerna eller utrustningen måste ha levererats av deras arbetsgivare eller av de självständiga företagarna själva till företaget där reparationen/underhållet ägde rum. Sådana tekniker får inte stanna på belgiskt territorium i <strong>mer än 5 dagar per månad</strong>.',
    'exceptionExtraInformation': 'Mer information',
    'exceptionConfirmationIntro': 'Jag bekräftar härmed att jag följer följande undantagsregel:',
    'exceptionFrom': 'Från',
    'exceptionTo': 'Till',
    'exceptionSignature': 'Underskrift',
    'exceptionIndependence': 'Jag bekräftar härmed att jag är självständig enligt belgisk lag:',
    'GroupSelectionText': 'För vilket företag utför du denna uppgift?',
    'CountryLocationText': 'Var är ditt företag registrerat?',
    'EmployeeLocationText': 'Var är du registrerad?',
    'selfEmployedText': 'Är du egenföretagare?',
    'yes': 'Ja',
    'no': 'Nej',
    'lblNL': 'Nederländerna',
    'lblNonNL': 'Annan nation',
    'nationalityText': 'Välj din nationalitet',
    'exceptionSelectionText': 'Är ditt besök täckt av ett av följande undantag?',
    'durationSelectionText': 'Stannar du längre än 90 dagar?',
    'scanningHelperText': 'Mer information',
    'nationalityPlaceholder': 'Nationalitet',
    'expiredError': 'Dokumentet har utgått eller kommer att gå ut för snart',
    'a1NationalityMismatch': 'Medlemsstaten på ditt A1 (utfärdande land) stämmer inte överens med ditt svar i föregående steg. Gå tillbaka till föregående skärm och välj rätt svar.',
  },
  'TR': {
    'welcomeTitle': 'Sosyal uyumluluk kontrolü',
    'welcomeReason': 'Sosyal uyumluluğu sağlamak için bazı sorular sormamız ve bazı belgeleri doğrulamamız gerekiyor.',
    'finishedTitle': 'Göndermeye hazır',
    'finishedReason': 'Gönderildiğinde, sağladığınız veriler dikkatle incelenecek ve ek kontroller gerekebilir.',
    'scanningTitle': 'Belgelerinizi yükleyin',
    'scanningText': 'Kenarların görünür olduğu ve tüm metnin açıkça okunabilir olduğu belgenizin bir görüntüsünü çekin veya seçin.',
    'errorNotRecognised': 'Belge tanınmadı',
    'errorWrongType': '{expectedType} dosyası bekliyorduk ama {uploadedFileType} sağladınız',
    'lblExpires': 'Doluyor',
    'lblUploadOrCapture': 'İstenen belgenin bir görüntüsünü yükleyin veya çekin',
    'lblVAT': 'KDV',
    'VATText': 'Lütfen KDV numaranızı girin',
    'VATError': 'Bu geçerli bir KDV numarası değil, lütfen doğru bir KDV numarası girdiğinizden emin olun',
    'lblBE': 'Belçika',
    'lblNonBE': 'Diğer ülke',
    'lblEER': 'AEA ülkesi (AB27 (BE dahil) / İzlanda / Norveç / Liechtenstein / İsviçre)',
    'lblNonEER': 'Diğer ülke',
    'employeeDetailText': 'Lütfen aşağıdaki bilgileri sağlayın',
    'requestException': 'Bir istisna talep etmek istiyorum',
    'requestExceptionProofOfIndependence': 'Bağımsızlık kanıtım yok',
    'exceptionIntroLimosa': 'Aşağıdaki istisnalardan birine uyuyorsanız, Limosa başvurusu yapmanıza gerek yoktur.',
    'installationAndAssembly': 'Kurulum ve montaj (maks. 8 gün)',
    'exceptionFirstDescriptionLimosa': 'Belçika\'ya malların ilk montajı ve/veya kurulumu için gönderilen işçiler ve serbest meslek sahipleri muaf tutulur. Bu, yalnızca malları tedarik eden işletmedeki nitelikli ve/veya uzman işçilere veya serbest tedarikçiye uygulanır. <strong>İş 8 günü aşamaz.</strong> Bu muafiyet inşaat sektörü için geçerli değildir.',
    'urgentRepairAndMaintenanceWork': 'Acil onarım ve bakım işleri (maks. 5 gün)',
    'exceptionSecondDescriptionLimosa': 'Yabancı şirketlerden uzman teknisyenler ve serbest meslek sahipleri, Belçika\'ya makineler veya ekipmanlar üzerinde acil bakım veya onarım işleri yapmak için gelirlerse muaf tutulur. Makineler veya ekipmanlar, işverenleri veya serbest meslek sahipleri tarafından onarım/bakımın yapıldığı işletmeye teslim edilmiş olmalıdır. Bu tür teknisyenler Belçika topraklarında <strong>ayda 5 günden fazla</strong> kalamazlar.',
    'exceptionExtraInformation': 'Daha fazla bilgi',
    'exceptionConfirmationIntro': 'Bununla aşağıdaki istisna kuralına uyduğumu onaylıyorum:',
    'exceptionFrom': 'Başlangıç',
    'exceptionTo': 'Bitiş',
    'exceptionSignature': 'İmza',
    'exceptionIndependence': 'Bununla Belçika yasasına göre bağımsız olduğumu onaylıyorum:',
    'GroupSelectionText': 'Hangi şirket için bu görevi gerçekleştiriyorsunuz?',
    'CountryLocationText': 'Şirketiniz nerede kayıtlı?',
    'EmployeeLocationText': 'Nerede kayıtlısınız?',
    'selfEmployedText': 'Serbest meslek sahibi misiniz?',
    'yes': 'Evet',
    'no': 'Hayır',
    'lblNL': 'Hollanda',
    'lblNonNL': 'Diğer ülke',
    'nationalityText': 'Lütfen uyruğunuzu seçin',
    'exceptionSelectionText': 'Ziyaretiniz aşağıdaki istisnalardan biri tarafından kapsanıyor mu?',
    'durationSelectionText': '90 günden uzun kalıyor musunuz?',
    'scanningHelperText': 'Daha fazla bilgi',
    'nationalityPlaceholder': 'Uyruk',
    'expiredError': 'Belge süresi dolmuş veya çok yakında dolacak',
    'a1NationalityMismatch': 'A1 belgenizdeki üye devlet (düzenleyen ülke), önceki adımda verdiğiniz cevapla uyuşmuyor. Önceki ekrana dönün ve doğru cevabı seçin.',
  },
  'UK': {
    'welcomeTitle': 'Перевірка соціальної відповідності',
    'welcomeReason': 'Для забезпечення соціальної відповідності нам потрібно поставити кілька питань і перевірити деякі документи.',
    'finishedTitle': 'Готово до відправлення',
    'finishedReason': 'Після відправлення надані дані будуть ретельно перевірені та може знадобитися додаткова перевірка.',
    'scanningTitle': 'Завантажте ваші документи',
    'scanningText': 'Зробіть або виберіть зображення вашого документа, де краї видні і весь текст чітко читається.',
    'errorNotRecognised': 'Документ не розпізнано',
    'errorWrongType': 'Ми очікували файл {expectedType}, але ви надали {uploadedFileType}',
    'lblExpires': 'Закінчується',
    'lblUploadOrCapture': 'Завантажте або зробіть зображення запитуваного документа',
    'lblVAT': 'ПДВ',
    'VATText': 'Будь ласка, надайте ваш номер ПДВ',
    'VATError': 'Це недійсний номер ПДВ, будь ласка, переконайтеся, що ви вводите правильний номер ПДВ',
    'lblBE': 'Бельгія',
    'lblNonBE': 'Інша країна',
    'lblEER': 'Країна ЄЕЗ (ЄС27 (включ. BE) / Ісландія / Норвегія / Ліхтенштейн / Швейцарія)',
    'lblNonEER': 'Інша країна',
    'employeeDetailText': 'Будь ласка, надайте таку інформацію',
    'requestException': 'Я хочу запросити виняток',
    'requestExceptionProofOfIndependence': 'У мене немає доказу незалежності',
    'exceptionIntroLimosa': 'Якщо ви відповідаєте одному з наступних винятків, вам не потрібно подавати заявку на Limosa.',
    'installationAndAssembly': 'Встановлення та збірка (макс. 8 днів)',
    'exceptionFirstDescriptionLimosa': 'Робітники та самозайняті, відправлені в Бельгію для початкової збірки та/або встановлення товарів, звільнені. Це стосується лише кваліфікованих та/або спеціалізованих робітників у компанії, що постачає товари, або самозайнятого постачальника. <strong>Робота не може перевищувати 8 днів.</strong> Цей виняток не стосується будівельного сектору.',
    'urgentRepairAndMaintenanceWork': 'Термінові ремонтні та обслуговуючі роботи (макс. 5 днів)',
    'exceptionSecondDescriptionLimosa': 'Спеціалізовані техніки з іноземних компаній та самозайняті звільнені, якщо вони приїжджають до Бельгії для виконання термінових робіт з обслуговування або ремонту машин або обладнання. Машини або обладнання повинні були бути доставлені їх роботодавцем або самими самозайнятими до компанії, де проводився ремонт/обслуговування. Такі техніки не можуть залишатися на бельгійській території <strong>більше 5 днів на місяць</strong>.',
    'exceptionExtraInformation': 'Більше інформації',
    'exceptionConfirmationIntro': 'Цим підтверджую, що я дотримуюся наступного правила винятку:',
    'exceptionFrom': 'Від',
    'exceptionTo': 'До',
    'exceptionSignature': 'Підпис',
    'exceptionIndependence': 'Цим підтверджую, що я незалежний згідно з бельгійським законодавством:',
    'GroupSelectionText': 'Для якої компанії ви виконуєте це завдання?',
    'CountryLocationText': 'Де зареєстрована ваша компанія?',
    'EmployeeLocationText': 'Де ви зареєстровані?',
    'selfEmployedText': 'Ви самозайнятий?',
    'yes': 'Так',
    'no': 'Ні',
    'lblNL': 'Нідерланди',
    'lblNonNL': 'Інша країна',
    'nationalityText': 'Будь ласка, виберіть вашу національність',
    'exceptionSelectionText': 'Чи покривається ваш візит одним з наступних винятків?',
    'durationSelectionText': 'Чи залишаєтеся ви довше 90 днів?',
    'scanningHelperText': 'Більше інформації',
    'nationalityPlaceholder': 'Національність',
    'expiredError': 'Документ закінчився або скоро закінчиться',
    'a1NationalityMismatch': 'Держава-член на вашому A1 (країна видачі) не відповідає відповіді, наданій на попередньому кроці. Поверніться на попередній екран і виберіть правильну відповідь.',
  },
};


export function getTextDefaults(lang) {
	return textDefaults[lang.toUpperCase()] || textDefaults['EN'];
}

export function getLanguages() {
	return Object.keys(textDefaults);
}
